module.exports = {
	 dev: {},
    uat: {},
    pdt: {
        // ajaxUrl: 'http://api.1shitou.com.cn:19541/FinInfoSite_F10/api/pc/',//f10
        // ajaxUrl1: 'http://marker.1shitou.com.cn/',//��Ʊ����
        // ajaxUrl2: 'http://api.1shitou.com.cn:19541/FinInfoSite_CmsData/pc/',//cms
        // ajaxUrl3: '',//��ʱ���ã�����Ҫ����
        // accountBaseUrl:'http://api.1shitou.com.cn:19541/user',//�˻�����
        // landUrl:'http://land.win-stock.com.cn/',//��½ҳ
        // orderUrl:'https://web.1shitou.cn/order', //������񶩵���ȡǩ��
        // jumpDeal:'https://order.1shitou.cn:15880', //���������ת����
        // getDealList:'https://web.1shitou.cn',//��ȡ�ҵĶ���list
        // checkDownload:'http://api.1shitou.com.cn:19541/AuthApi',//�������check
        // stockUrl:'http://www.1shitou.com/', //ʯͷ��web��վ��ַ��seo
        // currentUrl:'http://stock.1shitou.com:19539/',//��ǰ��Ŀurl
        // bindTelUrl:'https://icsa.1shitou.cn:9003/account/bindPhone',//��Ĭ���ֻ���
        // domainUrl:'1shitou.com'

        ajaxUrl: 'http://rpdtapi.1shitou.com.cn:19541/FinInfoSite_F10/api/pc/',//f10
        ajaxUrl1: 'http://rpdtstwmarker.1shitou.com.cn:10880/redis-api/realtime/',//��Ʊ����
        ajaxUrl2: 'http://rpdtapi.1shitou.com.cn:19541/FinInfoSite_CmsData/pc/',//cms
        // ajaxUrl3: 'http://172.27.64.11:8080/FinInfoSite_Fund/pc/',
        ajaxUrl3: '',
//      ajaxUrl4: 'https://223.100.7.112:5061/',
        // ajaxUrl5:'http://keji.brmlion.cn:5680/',//�Ƽ�����
        accountBaseUrl:'http://rpdtapi.1shitou.com.cn:19541/user',//�˻�����
        landUrl:'http://land.brmlion.com:7999/',//��½ҳ
        orderUrl:'https://uat0web.1shitou.cn:15443/order', //������񶩵���ȡǩ��
        jumpDeal:'https://uat0order.1shitou.cn:15880', //���������ת����
        getDealList:'https://uat0web.1shitou.cn:15443',//��ȡ�ҵĶ���list
        checkDownload:'http://rpdtapi.1shitou.com.cn:19541/AuthApi',//�������check
        stockUrl:'http://rpdtwww.1shitou.com/', //ʯͷ��web��վ��ַ��seo
        currentUrl:'http://rpdtstock.1shitou.com:19539/',//��ǰ��Ŀurl
        bindTelUrl:'https://uat0icsa.1shitou.cn:9003/account/bindPhone',//��Ĭ���ֻ���
        domainUrl:'1shitou.com'
    }
}



//////////////////
// WEBPACK FOOTER
// ./config/url.cof.pdt.js
// module id = d1K4
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41